import { Role } from "@/types/userDetails";

export function getExpenseTextClass(role: Role, createdAt: string) {
  if (role.isSuperAdmin) return "not-disabled";
  const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
  return new Date(createdAt) >= new Date(sevenDaysAgo)
    ? "not-disabled"
    : "disabled text-gray-500";
}

export function getExpenseEditAccess(role: Role, createdAt: string) {
  if (role.isSuperAdmin) return false;
  const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
  return new Date(createdAt) >= new Date(sevenDaysAgo) ? false : true;
}
